/* Little Boudoir — l'ajout au panier ouvre TOUJOURS le drawer (pas de saut vers /cart).
   Problème : Globo Product Options valide ses champs puis appelle form.submit() en
   NATIF. Or form.submit() ne déclenche pas l'événement « submit », donc le
   product-form.js de Dawn n'intercepte rien -> POST classique -> page /cart.
   Correctif : on remplace submit() sur les formulaires produit par un événement
   submit synthétique. Dawn l'attrape (preventDefault + fetch + ouverture du
   drawer). Si aucun écouteur ne le neutralise (drawer absent), on retombe sur
   le submit natif : comportement inchangé. */
(function () {
  function patch(form) {
    if (form.dataset.lbAjaxPatched) return;
    form.dataset.lbAjaxPatched = '1';
    form.submit = function () {
      var evt = new Event('submit', { bubbles: true, cancelable: true });
      this.dispatchEvent(evt);
      if (!evt.defaultPrevented) HTMLFormElement.prototype.submit.call(this);
    };
  }
  function apply() {
    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach(patch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);

  var origFetch = window.fetch;

  /* --- Re-rendu du panier (drawer ET page /cart) via l'API de rendu de sections.
     Exposé en window.lbCartRefresh : lb-perso.js l'appelle une fois les
     suppléments réellement ajoutés (réponse reçue) -> affichage déterministe,
     plus de course entre le rendu de Dawn et l'ajout des suppléments. --- */
  function remplacer(cible, html, selecteur) {
    if (!cible || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = selecteur ? doc.querySelector(selecteur) : doc.body;
    if (src) cible.innerHTML = src.innerHTML;
  }
  var rafraichissements = 0; /* appels à lbCartRefresh encore en vol (garde de la caisse) */
  function lbCartRefresh() {
    rafraichissements++;
    var drawer = document.querySelector('cart-drawer');
    var page = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    /* page /panier : livraison offerte + compléments (sections/lb-cart-cro.liquid) */
    var cro = document.getElementById('LbCartCro');
    var ids = ['cart-icon-bubble'];
    if (drawer) ids.push('cart-drawer');
    if (page && page.dataset.id) ids.push(page.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    if (cro && cro.dataset.id) ids.push(cro.dataset.id);
    return origFetch('/?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && sections['cart-drawer']) {
          remplacer(drawer, sections['cart-drawer'], 'cart-drawer');
          var vide = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer.is-empty');
          drawer.classList.toggle('is-empty', !!vide);
          /* le voile a été re-rendu : on lui rebranche la fermeture (comme Dawn) */
          var voile = drawer.querySelector('#CartDrawer-Overlay');
          if (voile && typeof drawer.close === 'function') voile.addEventListener('click', drawer.close.bind(drawer));
        }
        remplacer(document.getElementById('cart-icon-bubble'), sections['cart-icon-bubble'], '#cart-icon-bubble');
        if (page && sections[page.dataset.id]) {
          remplacer(page.querySelector('.js-contents'), sections[page.dataset.id], '.js-contents');
          var frais = new DOMParser().parseFromString(sections[page.dataset.id], 'text/html').querySelector('cart-items');
          var actuel = page.closest('cart-items');
          if (frais && actuel) actuel.classList.toggle('is-empty', frais.classList.contains('is-empty'));
        }
        if (footer && sections[footer.dataset.id]) {
          remplacer(footer.querySelector('.js-contents'), sections[footer.dataset.id], '.js-contents');
          /* panier vidé par la synchro : le pied (sous-total, « Paiement ») disparaît, comme chez Dawn */
          var piedFrais = new DOMParser().parseFromString(sections[footer.dataset.id], 'text/html').getElementById('main-cart-footer');
          if (piedFrais) footer.classList.toggle('is-empty', piedFrais.classList.contains('is-empty'));
        }
        if (cro && sections[cro.dataset.id]) {
          remplacer(cro, sections[cro.dataset.id], '#LbCartCro');
        }
        return sections;
      })
      .catch(function () { /* au pire, l'affichage reste tel quel */ })
      .then(function (sections) { rafraichissements--; return sections; });
  }
  window.lbCartRefresh = lbCartRefresh;

  /* --- Synchronisation des lignes d'options ---
     1. Moteur maison : la ligne principale porte properties._lb_cle ; ses suppléments
        portent properties._lb_pour = même clé. Après chaque mouvement de panier :
        · supplément orphelin (produit principal supprimé) -> retiré ;
        · quantité du supplément alignée sur celle du principal ;
        · réparation : la ligne principale liste ses suppléments attendus
          (properties._lb_sups, posé par lb-perso.js). S'il en manque un (onglet fermé,
          erreur entre les deux ajouts), on le rajoute ; si c'est impossible
          (option retirée de la vente), on retire l'article : jamais de vente sans
          l'option payée. Idempotent : on ne rajoute que ce qui manque.
        Indépendant de l'interrupteur Globo (un panier rempli avant la bascule reste juste).
     2. Globo coupé (pas de window.GPOConfigs.appEmbed) : plus personne ne suit ses lignes déjà
        au panier. On applique SA règle : option (_gpo_parent_product_group) orpheline
        -> retirée ; sinon quantité = celle de l'article (_gpo_product_group), sauf pour
        les options à quantité particulière (_gpo_one_time_charge, _gpo_quantity_*,
        _gpo_per_character), qu'on ne touche pas. Globo actif : on ne touche à rien.
     Filet de sécurité : dans le drawer et sur /cart, les lignes de supplément
     n'ont ni bouton de suppression ni sélecteur de quantité (verrouillées),
     mais /cart/change.js reste joignable par n'importe quel script. */
  var GRACE_REPARATION = 20000; /* ms laissées à lb-perso.js pour ajouter les suppléments */
  var MODES_QTE_GLOBO = ['_gpo_one_time_charge', '_gpo_quantity_fixed', '_gpo_quantity_dynamic', '_gpo_quantity_mix', '_gpo_per_character'];
  var sync = { timer: null, chargement: null, grace: null, enCours: false, relance: false, mutations: 0, promesse: null };

  /* gpomain.js crée lui-même un GPOConfigs vide : seul appEmbed (posé par l'intégration) prouve que Globo tourne */
  function globoCoupe() {
    return !(window.GPOConfigs && window.GPOConfigs.appEmbed) && !!(window.lbPerso && window.lbPerso.maison);
  }
  /* la synchro peut changer ce qui part en caisse : lignes maison au panier, ou Globo coupé */
  function syncUtile() {
    return globoCoupe() || !!document.querySelector('.lb-cart-sup, input[name="lb_qty"]');
  }
  function syncEnAttente() {
    return !!(sync.timer || sync.chargement || sync.grace || sync.enCours || sync.mutations > 0 || rafraichissements > 0);
  }
  /* quantité tapée mais pas encore envoyée par Dawn (champs lb_qty et updates[] : Dawn les
     envoie lui-même par /cart/change.js ; à la caisse, ils ne partent pas avec le formulaire) */
  function qtesNonEnvoyees() {
    var champs = document.querySelectorAll('input[name="lb_qty"], input[name="updates[]"]');
    for (var i = 0; i < champs.length; i++) {
      if (champs[i].value !== champs[i].getAttribute('value')) return true;
    }
    return false;
  }
  function majEtat() {
    document.documentElement.classList.toggle('lb-sync', !!(sync.timer || sync.chargement || sync.grace || sync.enCours || sync.mutations > 0) && syncUtile());
  }
  /* pendant que la synchro (ou lb-perso.js) retire ou ajoute des lignes, les index de ligne
     affichés sont périmés (Dawn modifie par position) : on bloque les lignes. Compteur et
     classe à nous sur <html> (html.lb-verrou, lb-design.css) : ni Dawn (qui gère sa propre
     classe cart__items--disabled) ni un re-rendu du tiroir ne peuvent lever le verrou d'un autre. */
  var verrous = 0;
  function verrouillerLignes(oui) {
    verrous = Math.max(0, verrous + (oui ? 1 : -1));
    document.documentElement.classList.toggle('lb-verrou', verrous > 0);
  }

  function lireSups(p) {
    if (!p._lb_sups) return null;
    try {
      var j = JSON.parse(p._lb_sups);
      return j && Array.isArray(j.s) ? j : null;
    } catch (e) { return null; }
  }

  /* calcule les changements à faire : { changes: [...], ajouts: [...], plusTard: ms (0 = rien) } */
  function planDeSynchro(cart) {
    var items = cart.items || [];
    var mains = {};
    var gpoMains = {};
    var enVol = (window.lbPerso && window.lbPerso.enVol) || {};
    var coupe = globoCoupe();
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._lb_cle && !mains[p._lb_cle]) mains[p._lb_cle] = it;
      if (coupe && p._gpo_product_group && !gpoMains[p._gpo_product_group]) gpoMains[p._gpo_product_group] = it;
    });
    var plan = { changes: [], ajouts: [], plusTard: 0 };
    items.forEach(function (it) {
      var p = it.properties || {};
      var main;
      if (p._lb_pour) {
        main = mains[p._lb_pour];
        if (!main) plan.changes.push({ id: it.key, quantity: 0 });
        else if (it.quantity !== main.quantity) plan.changes.push({ id: it.key, quantity: main.quantity });
      } else if (coupe && p._gpo_parent_product_group) {
        main = gpoMains[p._gpo_parent_product_group];
        if (!main) plan.changes.push({ id: it.key, quantity: 0 });
        else if (it.quantity !== main.quantity && !MODES_QTE_GLOBO.some(function (k) { return p[k] !== undefined; })) {
          plan.changes.push({ id: it.key, quantity: main.quantity });
        }
      }
    });
    /* réparation des suppléments manquants, comptés par variante (deux options au même
       montant partagent la même variante ; le libellé ne sert qu'à choisir lequel rajouter) */
    Object.keys(mains).forEach(function (cle) {
      var main = mains[cle];
      var sups = lireSups(main.properties || {});
      if (!sups || !sups.s.length || enVol[cle]) return;
      var presents = {};
      items.forEach(function (it) {
        var p = it.properties || {};
        if (p._lb_pour !== cle) return;
        var v = String(it.variant_id);
        (presents[v] = presents[v] || []).push(String(p.Option || '').trim());
      });
      var attendus = {};
      sups.s.forEach(function (s) {
        var v = String(s.v);
        (attendus[v] = attendus[v] || []).push(String(s.o || ''));
      });
      var manquants = [];
      Object.keys(attendus).forEach(function (v) {
        var dispo = (presents[v] || []).slice();
        var nb = attendus[v].length - dispo.length;
        if (nb <= 0) return;
        var restants = attendus[v].filter(function (o) {
          var i = dispo.indexOf(o.trim());
          if (i === -1) return true;
          dispo.splice(i, 1);
          return false;
        });
        restants.slice(0, nb).forEach(function (o) { manquants.push({ v: parseInt(v, 10), o: o }); });
      });
      if (!manquants.length) return;
      /* rien ne manque : pas de délai de grâce (sinon « Paiement » attendrait pour rien) */
      var age = typeof sups.t === 'number' ? Date.now() - sups.t : Infinity;
      if (age < GRACE_REPARATION) { /* ajout peut-être en cours dans un autre onglet : on repasse plus tard */
        var reste = GRACE_REPARATION - age + 500;
        if (!plan.plusTard || reste < plan.plusTard) plan.plusTard = reste;
        return;
      }
      plan.ajouts.push({ cle: cle, main: main, manquants: manquants });
    });
    return plan;
  }

  function changer(a) {
    return origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(a)
    });
  }
  /* applique le plan, une requête après l'autre ; résout true si le panier a bougé */
  function appliquer(plan) {
    var chain = Promise.resolve();
    var fait = false;
    plan.changes.forEach(function (a) {
      chain = chain.then(function () { fait = true; return changer(a); });
    });
    plan.ajouts.forEach(function (r) {
      chain = chain.then(function () {
        fait = true;
        return origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: r.manquants.map(function (m) {
              return { id: m.v, quantity: r.main.quantity, properties: { _lb_pour: r.cle, 'Option': m.o } };
            })
          })
        }).then(function (resp) {
          if (resp.ok) return;
          /* option définitivement indisponible : on retire l'article (ses autres
             suppléments deviennent orphelins et partent au passage suivant) */
          if (resp.status === 422 || resp.status === 404) {
            sync.relance = true;
            return changer({ id: r.main.key, quantity: 0 });
          }
          /* erreur passagère : on réessaiera au prochain passage */
        });
      });
    });
    return chain.then(function () { return fait; });
  }

  /* F2 : une demande arrivée pendant un passage n'est jamais perdue (drapeau relance). */
  function lbReconcileCart() {
    if (sync.enCours) { sync.relance = true; return sync.promesse; }
    sync.enCours = true;
    majEtat();
    var verrou = false;
    sync.promesse = origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var plan = planDeSynchro(cart);
        /* délai de grâce suivi (sync.grace) : « Paiement » l'attend, l'express reste retenu */
        clearTimeout(sync.grace);
        sync.grace = plan.plusTard ? setTimeout(function () { sync.grace = null; planifier(0); }, plan.plusTard) : null;
        if (plan.ajouts.length || plan.changes.some(function (a) { return a.quantity === 0; })) {
          verrou = true;
          verrouillerLignes(true);
        }
        return appliquer(plan);
      })
      .then(function (fait) { return fait ? lbCartRefresh() : null; })
      .catch(function () {})
      .then(function () {
        if (verrou) verrouillerLignes(false);
        sync.enCours = false;
        if (sync.relance) { sync.relance = false; return lbReconcileCart(); }
        majEtat();
      });
    return sync.promesse;
  }
  function planifier(delai) {
    clearTimeout(sync.timer);
    sync.timer = setTimeout(function () {
      sync.timer = null;
      lbReconcileCart();
    }, delai);
    majEtat();
  }
  /* promesse résolue quand plus rien n'est en cours (8 s au plus, 22 s si une réparation est
     en délai de grâce : on ne bloque jamais la caisse indéfiniment) */
  function attendreSynchro() {
    var debut = Date.now();
    var plafond = 8000;
    return new Promise(function (resolve) {
      (function tour() {
        if (sync.chargement) { clearTimeout(sync.chargement); sync.chargement = null; planifier(0); }
        if (sync.grace) plafond = GRACE_REPARATION + 2000;
        var calme = !syncEnAttente() && !qtesNonEnvoyees();
        if ((calme && Date.now() - debut >= 150) || Date.now() - debut > plafond) return resolve();
        setTimeout(tour, 100);
      })();
    });
  }
  window.lbCartSync = { attendre: attendreSynchro, lancer: lbReconcileCart, verrouiller: verrouillerLignes };

  /* F3 — « Paiement » pendant une synchro : on retient le passage en caisse, on attend la
     fin de la synchro (quantités d'options justes), puis on le relance. Les boutons de
     paiement express du panier ne peuvent pas être retenus : ils sont désactivés en CSS
     tant que html.lb-sync est posé (lb-design.css). Panier sans ligne d'option et
     Globo actif : rien ne change. */
  var caisseEnAttente = false;
  var caissePassage = false;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var bouton = e.submitter;
    if (!f || !bouton || bouton.name !== 'checkout') return;
    if (!syncUtile()) return;
    /* champs updates[] (tiroir rendu avant l'ajout des suppléments) : Shopify les applique PAR
       POSITION et décalerait les quantités. Dawn a déjà envoyé chaque changement par
       /cart/change.js : ils ne partent jamais en caisse (réactivés si la page revient du cache). */
    Array.prototype.forEach.call(f.elements, function (c) {
      if (c.name === 'updates[]' && !c.disabled) { c.disabled = true; c.setAttribute('data-lb-coupe', ''); }
    });
    /* relance après l'attente (plafond atteint compris) : on laisse passer, sinon une quantité
       jamais envoyée (réseau coupé) retiendrait la caisse sans fin. Le panier du serveur fait foi. */
    if (caissePassage) { caissePassage = false; return; }
    if (!(syncEnAttente() || qtesNonEnvoyees())) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (caisseEnAttente) return;
    caisseEnAttente = true;
    bouton.setAttribute('aria-busy', 'true');
    var idForm = f.id;
    var idBouton = bouton.id;
    attendreSynchro().then(function () {
      caisseEnAttente = false;
      /* le tiroir a pu être re-rendu entre-temps : on reprend les éléments à jour */
      var nf = (idForm && document.getElementById(idForm)) || f;
      var nb = (idBouton && document.getElementById(idBouton)) || bouton;
      nb.removeAttribute('aria-busy');
      if (nb.disabled || !nf.isConnected) return; /* panier vidé par la synchro */
      caissePassage = true;
      try { nf.requestSubmit(nb); } catch (err) { nb.click(); }
      caissePassage = false; /* le submit est synchrone : le drapeau ne survit pas à ce passage */
    });
  }, true);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('input[data-lb-coupe]').forEach(function (c) {
      c.disabled = false;
      c.removeAttribute('data-lb-coupe');
    });
  });

  /* Second filet : Globo (et d'autres apps) ajoutent via LEUR fetch('/cart/add.js')
     puis redirigent vers /cart. La redirection se désactive dans les réglages de
     l'app ; ici, on détecte tout ajout AJAX au panier qui n'ouvre pas le drawer
     et on l'ouvre nous-mêmes avec le contenu à jour (API de rendu de sections). */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = origFetch.apply(this, arguments);
    /* tout mouvement de panier (ajout, retrait, quantité) replanifie une synchro des
       lignes d'options, presque sans délai (F3) ; nos propres appels passent par
       origFetch. Une simple mise à jour de la note de commande ne compte pas. */
    var corps = init && typeof init.body === 'string' ? init.body : '';
    var noteSeule = /\/cart\/update/.test(url) && /"note"/.test(corps) && !/"updates"|"attributes"/.test(corps);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && !noteSeule) {
      sync.mutations++;
      majEtat();
      promise.then(function (resp) {
        if (resp.ok) planifier(50);
      }, function () {}).then(function () {
        sync.mutations--;
        majEtat();
      });
    }
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      promise.then(function (resp) {
        if (!resp.ok) return;
        // On laisse 400 ms à Dawn : s'il a géré l'ajout lui-même, le drawer est déjà ouvert.
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || drawer.classList.contains('active')) return;
          lbCartRefresh().then(function () {
            if (typeof drawer.open === 'function') drawer.open();
            else drawer.classList.add('animate', 'active');
          });
        }, 400);
      }, function () {});
    }
    return promise;
  };

  /* Passe de synchro au chargement (couvre les modifications faites sur la page panier
     classique, qui navigue au lieu de fetcher, les paniers d'avant la bascule et les
     réparations en attente). Garde bon marché : seulement si le panier contient des articles
     (pastille de l'en-tête LB ou de Dawn, ou lignes déjà rendues dans le tiroir / sur /cart).
     Si le client part en caisse avant, la garde ci-dessus la lance aussitôt. */
  var lbBadge = document.querySelector('#cart-icon-bubble .lb-cartcount, #cart-icon-bubble .cart-count-bubble');
  var lbLignes = document.querySelector('[id^="CartDrawer-Item-"], [id^="CartItem-"]');
  if ((lbBadge && lbBadge.textContent.trim() !== '') || lbLignes) {
    sync.chargement = setTimeout(function () {
      sync.chargement = null;
      majEtat();
      lbReconcileCart();
    }, 1500);
    /* express du panier retenu dès maintenant (html.lb-sync), jusqu'à la fin de cette passe */
    majEtat();
  }
})();
